import React, { Fragment, useState } from 'react';
import { injectIntl } from 'react-intl';
/*********************************************************
 * Controls
 *********************************************************/
import styles from 'Assets/sass/core/vars.scss';
import Popover from '@mui/material/Popover';
import ButtonToggleMap from '../ButtonToggleMap'

/*********************************************************
 * Icons
 *********************************************************/
import NavigationIcon from '@mui/icons-material/Navigation';
import LandmarkMarkerSvg from '../IconsSvg/LandmarkMarkerSvg'
import GeofenceSvg from '../IconsSvg/GeofenceSvg';

/*********************************************************
 * Style
 *********************************************************/
import './style.scss';
import { getLegends } from '../utils';

/*********************************************************
 * Author:  Walter Paz Londoño
 * Date:    28 Jan 2020
 * Module:  Realtime Maps
 * 
 * Class associated to the legends markers in realtime maps
 ********************************************************/
const LegendsToggle = (props) =>  {
    /********************************************************
     * Define const
     ********************************************************/
     const { messages } = props.intl;
     const LEGENDS = getLegends();

    const [isLegendsOpened, setIsLegendsOpened] = useState() 

    /********************************************************
     * Event to close legend component
     ********************************************************/
    const handleClose = () => {
        setIsLegendsOpened(null)
    };

    /********************************************************
     * Event to open legend component
     ********************************************************/
    const handleOpenLegend = (event) => {
        setIsLegendsOpened(event.currentTarget)
    }
    
    /********************************************************
     * Return the legend component
     ********************************************************/
    const open = Boolean(isLegendsOpened);
    const id = open ? 'simple-popover' : undefined;
    return (
        <Fragment>
            <ButtonToggleMap label={messages['map_legend']} open={open} onClick={handleOpenLegend} />
            <Popover
                id={id}
                open={open}
                anchorEl={isLegendsOpened}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div className={'legend-menu'}>
                    {
                        LEGENDS.map((legend, key) => {
                          const isFirstControl = legend.isControl && (key === 0 || !LEGENDS[key - 1]?.isControl);
                          return (
                            <Fragment key={key}>
                              {isFirstControl && <div className={'legend-separator'} />}
                              <div className={'legend-item'}>
                                {legend.isControl ? (
                                  <>
                                    <div className={'legend-iconFlag'}>
                                      {legend.control}
                                    </div>
                                    <span className={'legend-name'}>{legend.name}</span>
                                  </>
                                ) : (
                                  <>
                                    <NavigationIcon className={'navigation-icon'} style={{ color: `${legend.color}` }} />
                                    <span className={'legend-name'}>{legend.name}</span>
                                  </>
                                )}
                              </div>
                            </Fragment>
                          );
                        })
                    }
                </div>
            </Popover>
        </Fragment>
    )
}

export default injectIntl(LegendsToggle);